import styled from "@emotion/styled"
import { PortfolioWrapperRel } from "./portfolio-styles"

export const WebPortfolio = styled(PortfolioWrapperRel)`
  @media screen and (min-width: 1024px) {
    padding-left: 4rem;
    flex-direction: row;
  }
`

export const WebPortfolioLeftTitle = styled.p`
  font-family: "Montserrat", sans-serif;
  transform: scale(1, 0.9);
  font-weight: 700;
  text-transform: lowercase;
  text-decoration: none;
  line-height: 0.85;
  color: #fefefe;
  font-size: 4.5rem;
  position: relative;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    font-size: 6rem;
  }

  span {
    color: #fefefe;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke-color: #fefefe;
    -webkit-text-stroke-width: 1px;
    position: relative;
    right: 1.5rem;
    bottom: 1rem;
  }
`

export const WebPortfolioLeft = styled.div`
  color: #fefefe;
  text-align: right;
  z-index: 2;

  @media screen and (min-width: 1024px) {
    min-width: 450px;
    width: 40%;
    padding-left: 4rem;
  }

  p {
    font-family: "Montserrat", sans-serif;
    transform: scale(1, 0.9);
    max-width: 50%;
    margin-right: 2rem;
    margin-left: auto;

    :last-of-type {
      line-height: 1.8;
    }

    @media (min-width: 1024px) {
      max-width: 75%;
    }
  }
`

export const WebPortfolioRight = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
  overflow: hidden;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: 1024px) {
    margin-top: 0;
    margin-right: 2rem;
    flex-direction: row;
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;

    ::-webkit-scrollbar {
      display: none;
    }
  }
`

export const WebPortfolioItemContent = styled.p`
  position: absolute;
  left: 50%;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  opacity: 0;
  transform: translate(-50%, -50%);
  transition: all 0.4s ease-in-out;
  z-index: 2;

  p {
    text-align: center;
    white-space: nowrap;
    font-size: 1.5rem;
    font-family: "Montserrat", sans-serif;
    transform: scale(1, 0.9);
    font-weight: 700;
    text-transform: lowercase;
    color: #fefefe;

    :last-of-type {
      font-size: 1rem;
      border-bottom: 2px solid #2497c6;
    }
  }

  .spacer {
    width: 1px;
    height: 12rem;
    background-color: #fefefe;
    display: block;
  }
`

export const WebPortfolioItem = styled.a`
  z-index: 1;
  position: relative;
  display: flex;
  margin-bottom: 4rem;
  max-height: 450px;

  @media (min-width: 1024px) {
    max-height: auto;
    margin: 8rem 2rem;
  }

  :hover {
    cursor: pointer;
    z-index: 2;

    .overlay {
      opacity: 0.7;
      transform: scale(1.05);
    }

    video {
      transform: scale(1.05);
    }

    ${WebPortfolioItemContent} {
      opacity: 1;
      transform: translate(-50%, -100%);
    }
  }

  .overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    background: #1e1e1e;
    opacity: 0;
    transition: all 0.4s ease-in-out;
  }

  video {
    max-width: 90vw;
    object-fit: cover;
    transition: all 0.4s ease-in-out;

    @media (min-width: 1024px) {
      max-width: 640px;
      max-height: 480px;
    }
  }
`

export const ProgressBar = styled.div`
  width: 1%;
  height: 8px;
  background-color: #2497c6;
  position: fixed;
  left: 0;
  bottom: 0;
  transition: all 1s ease-in-out;

  @media screen and (max-width: 1023px) {
    display: none;
  }
`
